export const getInitialState = (): any => ({
  modelAddingData: {},
  modelAddingStatus: 0
});
